export enum Persona {
  FISICA = 'fisica',
  MORAL = 'moral',
}
